import { gql } from "@apollo/client";

export default gql`
  mutation updatePlatform($type: PlatformType!, $metaData: UpdatePlatformInputData!){
    updatePlatform(type: $type, metaData: $metaData){
        success
        data
        code
        message
    }
}
`
